import { AnyAction, ThunkAction } from '@reduxjs/toolkit';
import type { DynamicObjectInterface } from '../type';
import NotificationService from '../services/notificationService';
import { LoggerService } from '../../ui/utils/logger';
import { UTCToLocal } from '../../ui/utils';
import notificationSlide from './notificationSlice';
import { RootState } from './index';

export const notificationActions = notificationSlide.actions;

export const fetchNotification = (lastRead = ''): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async dispatch => {
    try {
      const res: DynamicObjectInterface = await NotificationService.getNotification(lastRead);
      LoggerService.log('Fetch new notification', new Date().toISOString(), res.data.data.length);
      const _formattedResponse = res.data.data?.map((item: DynamicObjectInterface) => {
        item.createdDate = UTCToLocal(item.createdDate);
        return { ...item };
      });
      dispatch(notificationActions.setMessage(_formattedResponse));
    } catch (e) {
      LoggerService.log('Get Notification Error', e);
    }
  };
};

export const readMessage = (recId: number): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async dispatch => {
    try {
      await NotificationService.putReadMessage(recId);

      dispatch(notificationActions.removeMessage(recId));
    } catch (e) {
      LoggerService.log('Update Notification Error', e);
    }
  };
};

export const clearNotification = (): ThunkAction<void, RootState, unknown, AnyAction> => {
  return dispatch => {
    dispatch(notificationActions.clearMessage());
  };
};
